export { useTotalEnrollmentsByCourse } from './use-total-enrollments-by-course';
